<template>
  <v-container pa-0 fluid @touchstart="touchEnable">
    <v-layout>
      <v-flex xs12>

        <v-card tile class="pt-4 pb-4 mt-2 overflow-x-hidden card-shadow" v-if="isLoading">
          <v-progress-circular v-if="isLoading" indeterminate></v-progress-circular>
        </v-card>

        <v-card tile class="pt-3 pb-0 mt-2 overflow-x-hidden card-shadow" v-else-if="earlyBirds.length || inPreparations.length">

<!--          &lt;!&ndash; 얼리 버드 &ndash;&gt;-->
<!--          <template v-if="earlyBirds.length">-->
<!--            <v-card-title primary-title class="py-0">-->
<!--              <h1 class="display-4">얼리버드</h1>-->
<!--            </v-card-title>-->

<!--            <v-card-title class="py-0">-->
<!--              <v-layout row align-center>-->
<!--                <div style="flex-shrink: 0;">-->
<!--                  <span class="caption">런칭 전, 얼리버드로만 만나볼 수 있는 가격 🎉</span>-->
<!--&lt;!&ndash;                  <span class="caption caption-strong" v-text="`${earlyBirdsTotal}개`"></span>&ndash;&gt;-->
<!--&lt;!&ndash;                  <span class="caption" v-text="`의 얼리버드 스토리가 있습니다.`"></span>&ndash;&gt;-->
<!--                </div>-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-btn flat small class="custom-color-brown-grey pr-0 ma-0" style="min-width: unset;" :to="{ name: 'EarlyBird' }">-->
<!--                  <span class="caption">더보기</span>-->
<!--                  <v-icon color="#4a4a4a" size="16px">$vuetify.icons.arrowRight</v-icon>-->
<!--                </v-btn>-->

<!--              </v-layout>-->
<!--            </v-card-title>-->

<!--            <v-card-text class="ma-0 pt-3 px-0 pb-4">-->
<!--              <div :id="`slide-early-birds-${nationIdx}`"-->
<!--                   class="store-swiper-container swiper-container"-->
<!--                   style="padding: 0 16px">-->
<!--                <div class="store-swiper-wrapper swiper-wrapper">-->
<!--                  <div class="store-swiper-slide swiper-slide"-->
<!--                       v-for="(product, index) of earlyBirds" :key="index">-->
<!--                    <ProductCard :idx="product.idx"-->
<!--                                 :title="product.title"-->
<!--                                 :subtitle="product.subtitle"-->
<!--                                 :publishedAt="product.published_at"-->
<!--                                 :status="product.status"-->
<!--                                 :thumbnail="product.thumbnail"-->
<!--                                 :bookmarks="product.bookmarks"-->
<!--                                 :subtitle_color="product.subtitle_color"-->
<!--                                 @bookmark="bookmarkProduct(product.idx, 'earlyBirds')" />-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </v-card-text>-->
<!--          </template>-->

<!--          &lt;!&ndash; 신규 예정 &ndash;&gt;-->
<!--          <template v-if="inPreparations.length">-->
<!--            <v-card-title primary-title class="py-0">-->
<!--              <h1 class="display-4">신규 예정 클래스</h1>-->
<!--            </v-card-title>-->

<!--            <v-card-title class="py-0">-->
<!--              <v-layout row align-center>-->
<!--                <div style="flex-shrink: 0;">-->
<!--                  <span class="caption">❤️를 누르면 더 빨리 만나볼 수 있어요</span>-->
<!--&lt;!&ndash;                  <span class="caption caption-strong" v-text="`${inPreparationTotal}개`"></span>&ndash;&gt;-->
<!--&lt;!&ndash;                  <span class="caption" v-text="`의 신규 예정 클래스가 있습니다.`"></span>&ndash;&gt;-->
<!--                </div>-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-btn flat small class="custom-color-brown-grey pr-0 ma-0" style="min-width: unset;" :to="{ name: 'ComingSoon' }">-->
<!--                  <span class="caption">더보기</span>-->
<!--                  <v-icon color="#4a4a4a" size="16px">$vuetify.icons.arrowRight</v-icon>-->
<!--                </v-btn>-->

<!--              </v-layout>-->
<!--            </v-card-title>-->

<!--            <v-card-text class="ma-0 pt-3 px-0 pb-4">-->
<!--              <div :id="`slide-in-preparations-${nationIdx}`"-->
<!--                   class="store-swiper-container swiper-container"-->
<!--                   style="padding: 0 16px">-->
<!--                <div class="store-swiper-wrapper swiper-wrapper">-->
<!--                  <div class="store-swiper-slide swiper-slide"-->
<!--                       v-for="(product, index) of inPreparations" :key="index">-->
<!--                    <ProductCard :idx="product.idx"-->
<!--                                 :alarms="product.alarms"-->
<!--                                 :title="product.title"-->
<!--                                 :subtitle="product.subtitle"-->
<!--                                 :publishedAt="product.published_at"-->
<!--                                 :status="product.status"-->
<!--                                 :thumbnail="product.thumbnail"-->
<!--                                 :bookmarks="product.bookmarks"-->
<!--                                 :subtitle_color="product.subtitle_color"-->
<!--                                 @bookmark="bookmarkProduct(product.idx, 'inPreparations')"-->
<!--                                 @alarm="alarmProduct(product.idx)"-->
<!--                    />-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </v-card-text>-->
<!--          </template>-->

        </v-card>

        <!-- 선택된 카테고리 상품 목록 -->
        <v-card tile class="pt-0 pb-4 mt-2 overflow-x-hidden card-shadow">
          <v-card-title primary-title class="pb-0 pt-3">
            <h1 class="display-4">지금 시작하기</h1>
          </v-card-title>

          <v-card-title class="py-0">
            <v-layout row align-center>
              <div style="flex-shrink: 0;">
                <span class="caption" v-if="typeof type === 'undefined' || type === 'class'">유학생이 직접 알려주는 유학준비, 혼자서도 할 수 있어요 💪️</span>
                <span class="caption" v-else>유스와 함께 떠나는 ✈️ {{ tourName }}️</span>
              </div>
            </v-layout>
          </v-card-title>

          <v-card-text class="ma-0 pt-4 pl-0 pr-0 pb-0">
            <v-container fluid grid-list-md class="py-0">
              <v-layout row wrap>
                <v-flex xs6 v-for="(product, index) of products" :key="index">
                  <ProductCard :idx="product.idx"
                               :title="product.title"
                               :subtitle="product.subtitle"
                               :publishedAt="product.published_at"
                               :status="product.status"
                               :thumbnail="product.thumbnail"
                               :bookmarks="product.bookmarks"
                               :subtitle_color="product.subtitle_color"
                               @bookmark="bookmarkProduct(product.idx, 'products')" />
                </v-flex>

                <v-flex xs6 v-if="products.length < 2 || products.length % 2 !== 0">
                  <v-card flat>
                    <v-img :aspect-ratio="16/9" class="grey lighten-5"
                           style="padding: 6px; border-radius: 2px; margin-bottom: 10px;">
                      <v-layout class="fill-height" align-center justify-center>
                        <v-icon size="48px">$vuetify.icons.menuEllipsis</v-icon>
                      </v-layout>
                    </v-img>

                    <v-card-text class="pa-0 text-xs-left" style="line-height: 10px; margin-bottom: 6px;">
                      <span class="sub-text-style sub-title" :style="{ color: '#ec514f' }"
                            style="font-size: 10px; letter-spacing: -0.2px; font-weight: 700; opacity: 0.7">
                        기다려주세요!
                      </span>
                    </v-card-text>

                    <v-card-title primary-title class="pa-0 text-xs-left align-start line-clamping" style="min-height: 42px;">
                      <span class="body-2 mb-0" style="opacity: 0.7">더욱 다양한 컨텐츠를<br>준비중입니다.</span>
                    </v-card-title>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';

  import ProductCard from '@/components/ProductCard';
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'Products',
    components: { ProductCard },
    props: {
      nationIdx: {
        type: Number
      },
      activeTab: {
        type: String
      },
      type: {
        type: String
      },
      tourIdx: {
        type: Number
      }
    },
    computed: {
      ...mapGetters('tour', [ 'tourName', 'tourNations', 'tourNationIdx', 'tourNationName' ]),
      isActive () {
        return this.activeTab ? parseInt(this.activeTab.split('-')[1]) === parseInt(this.nationIdx) : true;
      }
    },
    data () {
      return {
        isLoading: true,
        second: parseInt(new Date().getTime() / 1000),
        earlyBirdsTotal: 0,
        earlyBirds: [],
        inPreparationTotal: 0,
        inPreparations: [],
        page: 1,
        maxPage: 2,
        products: [],
        bottom: true,
        swipers: [],
      };
    },
    created () {
      this.select();
      window.addEventListener('scroll', this.bottomVisible);
    },
    mounted () {
      this.swiperInit();
    },
    updated () {
      this.swiperInit();
    },
    beforeDestroy () {
      if (this.swipers.length) this.swipers.forEach(swiper => {
        swiper.destroy();
      });
    },
    destroyed () {
      window.removeEventListener('scroll', this.bottomVisible);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (bottom && !oldBottom) {
          this.select();
        }
      },
    },
    methods: {
      ...mapActions('product', [ 'selectStorePre', 'selectProducts', 'toggleBookmark', 'toggleAlarm' ]),
      ...mapMutations('home', { mutationToggleStoreBookmark: 'TOGGLE_STORE_BOOKMARK' }),
      select () {
        if (this.isActive) {
          // if (this.page === 1) { // 얼리버드. 신규예정
          //   this.selectStorePre({
          //     type: this.type ? this.type : undefined,
          //     tourIdx: this.tourIdx ? this.tourIdx : undefined,
          //     nationIdx: parseInt(this.nationIdx) === 0 ? undefined : this.nationIdx,
          //     second: this.second
          //   }).then(response => {
          //     this.earlyBirds = response.data.earlybird;
          //     this.earlyBirdsTotal = response.data.earlybird_total;
          //     this.inPreparations = response.data.ready;
          //     this.inPreparationTotal = response.data.ready_total;
          //   }).catch(err => {
          //     console.error(err);
          //   }).finally(() => {
          //     this.isLoading = false;
          //   });
          // }
          if (this.page <= this.maxPage) {
            this.selectProducts({
              // status: 'forsale',
              type: this.type ? this.type : undefined,
              tourIdx: this.tourIdx ? this.tourIdx : undefined,
              nationIdx: parseInt(this.nationIdx) === 0 ? undefined : this.nationIdx,
              page: this.page,
              second: this.second,
            }).then(response => {
              this.maxPage = response.max_page;
              this.products.push(...response.data);
              this.page++;
            }).catch(err => {
              console.error(err);
            }).finally(() => {
              this.isLoading = false;
            });
          }
        }
      },
      touchCancel () {
        this.$eventBus.$emit('touchCancel', true);
      },
      touchEnable () {
        this.$eventBus.$emit('touchCancel', false);
      },
      swiperInit () {
        let root = this;
        let containers = document.querySelector('.store-swiper-container');
        if (containers) {
          let swiper = new Swiper('.store-swiper-container', {
            direction: 'horizontal',
            slidesPerView: 2,
            spaceBetween: 10,
            on: {
              init () {
                this.el.classList.remove('store-swiper-container');
              },
              touchMove() {
                root.touchCancel();
              },
            }
          });
          if (typeof swiper.length !== 'undefined') this.swipers.push(...swiper);
          else this.swipers.push(swiper);
        }
      },
      bookmarkProduct (idx, location) {
        this.toggleBookmark(idx).then(response => {
          let target = this[location].find(el => {
            return el.idx === idx;
          });
          target.bookmarks = response.data;
          this.mutationToggleStoreBookmark({ idx, flag: response.data });
          this.$forceUpdate(); // inPreparations(신규 예정 스토리)에 있는 애들이 왜인지 업데이트가 안 되어서 걸어놓음
        }).catch(err => {
          console.error(err);
        });
      },
      alarmProduct (idx) {
        this.toggleAlarm(idx).then(response => {
          let target = this.inPreparations.find(el => {
            return el.idx === idx;
          });
          target.alarms = response.data;
        }).catch(err => {
          console.error(err);
        });
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 100;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
    }
  }
</script>

<style lang="scss" scoped>
  // custom grid-list-md gutter settings
  /deep/.container.grid-list-md .layout:only-child {
    margin: -5px;
  }
  /deep/.container.grid-list-md .layout .flex {
    padding: 5px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .caption {
    color: map_get($colors, brownish-grey);
  }

  .caption-strong {
    font-weight: 700;
    color: map_get($colors, primary);
  }
</style>
